//@flow
import {Button, makeStyles} from '@material-ui/core';
import React from 'react';
import {colors} from '../../../../../../../assets/styles/colors';
import Layout1 from './Layout1';
import Layout2 from './Layout2';

import {POPUP_BANNER_LAYOUTS} from '../constants';
import {useFormContext} from 'react-hook-form';
import {POPUP_BANNER_FIELDS} from '../constants';

const useStyles = makeStyles(theme => ({
  items: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  itemButton: {
    flexGrow: 1,
    padding: 0,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  item: {
    width: '100%',
    height: '100%',
    background: '#F2F2F2',
    borderRadius: '.5rem',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '.75rem',
    cursor: 'pointer',
    position: 'relative',

    '&[data-hide-thumbnail=true]': {
      flexDirection: 'row',
      alignItems: 'center',
      padding: '1rem',
      justifyContent: 'flex-start',
      gap: '1rem',
    },
  },
  itemLabel: {
    display: 'block',
    textAlign: 'center',
    color: colors.grey600,
    fontSize: '.75rem',
  },
  layoutThumbnail: {
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    position: 'absolute',
    top: '.5rem',
    left: '.5rem',
    width: '1.25rem',
    height: '1.25rem',
    background: '#fff',
    borderRadius: '50%',
    border: '1px solid #E0E0E0',
    transition: 'border .2s ease-in-out',

    '&[data-checked=true]': {
      border: `.35rem solid ${colors.primary}`,
    },

    '&[data-hide-thumbnail=true]': {
      position: 'relative',
      top: 0,
      left: 0,
    },
  },
}));
type Layout = {
  name: string,
  component: React$Node,
  label: string,
};

type Props = {
  hideThumbnail?: boolean,
};

const LAYOUTS: Layout[] = [
  {
    name: POPUP_BANNER_LAYOUTS.BELOW,
    component: <Layout1 />,
    label: 'Vertical - Imágen + Texto + Botón',
  },
  {
    name: POPUP_BANNER_LAYOUTS.CENTER,
    component: <Layout2 />,
    label: 'Central - Imagen + Texto + Botón',
  },
];

export default function PopupBannerLayout({hideThumbnail}: Props) {
  const classes = useStyles();
  const {setValue, watch} = useFormContext();

  const layoutSelected = watch(POPUP_BANNER_FIELDS.CONTENT_POSITION);

  return (
    <div className={classes.items}>
      {LAYOUTS.map(layout => (
        <Button
          key={layout.name}
          className={classes.itemButton}
          onClick={() => {
            setValue(POPUP_BANNER_FIELDS.CONTENT_POSITION, layout.name);
          }}
        >
          <div className={classes.item} data-hide-thumbnail={hideThumbnail}>
            <div
              className={classes.checkbox}
              data-hide-thumbnail={hideThumbnail}
              data-checked={layoutSelected === layout.name}
            ></div>
            {!hideThumbnail && (
              <div className={classes.layoutThumbnail}>{layout.component}</div>
            )}
            <span className={classes.itemLabel}>{layout.label}</span>
          </div>
        </Button>
      ))}
    </div>
  );
}
